<template>
  <v-container grid-list-xl fluid ma-3 text-xs-center>
    <v-layout justify-center wrap row>
      <v-flex xs12 headline ma-3>
        We sent a verification code to your email address. Please enter your code.
      </v-flex>
      <v-flex xs12 sm5 elevation-2 white pa-5 style="max-width:400px">
        <v-alert
          :value="error"
          type="error"
          outline
        >
          {{ error }}
        </v-alert>
        <v-text-field
          outline
          label="Verification Code"
          v-model="code"
          class="codeInput"
          maxlength="6"
          @keyup.enter="verify">
        </v-text-field>
        <v-btn color="secondary" large @click="verify">
          Submit
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap row>
      <v-flex xs12 mt-5 text-xs-center>
        If you do not receive your email within 5 minutes please check your spam folder or email support@brainingcamp.com and we'll help out!
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      error: null,
      code: null,
      resent: false,
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  components: {
  },
  mounted: function () {
  },
  methods: {
    async verify () {
      try {
        const response = await AuthenticationService.processVerificationCode({
          token: this.$store.getters.token,
          code: this.code
        })

        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({
          name: 'root'
        })
      } catch(err) {
        if (err.response.status === 403) {
          this.$router.push({
            path: '/logout'
          })
        } else {
          this.error = err.response.data.error;
        }
      }
      
    },
    async resend () {
      try {
        const response = await AuthenticationService.resendVerificationCode()
        this.resent = true
      } catch(err) {
        console.log(err.response.data.error);
      }
    }
  }
}
</script>

<style scoped>

.codeInput >>> input {
  text-transform: uppercase;
}

</style>


